import GraphicWarehousePage from './graphic-warehouse-page';

export default GraphicWarehousePage;
